module.exports = __webpack_public_path__ + "static/SoybeanLecithin-5499773f7b0ea45b942a658ea43e9de3.webp";